import axios from "axios";
import { useAuthStore } from "@/stores";
import { attachUnauthorizedInterceptor } from "@/composable/handleUnauthorized";
import { getBearerToken } from "@/composable/getBearerToken";

// Covers call sites that use the raw `axios` singleton directly
// (e.g. auth.store.js login, helpers/index.js) instead of an instance
// created below.
attachUnauthorizedInterceptor(axios);

export default {
  createAxiosInstance() {
    const authStore = useAuthStore();

    const instance = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      withCredentials: true,
    });

    instance.interceptors.request.use((config) => {
      const token = getBearerToken(authStore.$state.token);

      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    });

    attachUnauthorizedInterceptor(instance);

    return instance;
  },
};
